import React, { Component } from 'react'
import { connect} from 'react-redux';
import {Button, Form, FormGroup, Label, 
    Col,Input, InputGroup, InputGroupAddon, 
    CustomInput, InputGroupText} from 'reactstrap';
import Calendario from '../UI/Calendario/Calendario';
import classes from '../NuovaVendita/NuovaVendita.module.css';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux_/Aux';
import axios from '../../hoc/axios-vendite';
import { Spinner } from 'reactstrap';

class ModificaVendita extends Component {

    state = this.initialState;

    get initialState() {
        return {
            loading: false,
            formError: '',
            formVisible: {
                switchForm: false,
                montatura: false,
                lenti: false,
                lac: false,
                liquido: false,
                altro: false
            },
            marcheLista: null,
            currentIdVendita: null,
            vendita: {
                
                dataVendita: {  value: '',
                                validation: { required: false },                                          
                                valid: true
                             },
                tipoVendita: {  value: '',
                                validation: { required: false },                                            
                                valid: true },
                tipoMontatura: {    value: '',
                                    validation: { required: false },                                            
                                    valid: true },
                marcaMontatura:{    value: '',
                                    validation: { required: false },                                            
                                    valid: true },
                prezzoMontatura: {  value: '',
                                    validation: { required: false },                                            
                                    valid: true },        
                tipoLenti: {    value: '',
                                validation: { required: false },                                            
                                valid: true },
                transition: {   value: false,
                                validation: { required: false },                                            
                                valid: true },
                colorate: {     value: false,
                                validation: { required: false },                                            
                                valid: true },
                prezzoLenti: {  value: '',
                                validation: { required: false },                                            
                                valid: true },
                tipoLac: {      value: '',
                                validation: { required: false },                                            
                                valid: true },
                marcaLac: {     value: '',
                                validation: { required: false },                                            
                                valid: true },
                prezzoLac: {    value: '',
                                validation: { required: false },                                            
                                valid: true },
                tipoLiquido: {  value: '',
                                validation: { required: false },                                            
                                valid: true },
                prezzoLiquido: {    value: '',
                                    validation: { required: false },                                            
                                    valid: true },
                altro:{         value: '',
                                validation: { required: false },                                            
                                valid: true },
                prezzoAltro:{   value: '',
                                validation: { required: false },                                            
                                valid: true },
            }
        }       
    }

            componentDidMount(){
               this.caricaDati();  
            }

            componentDidUpdate(){
                //console.log('Componend Did update');
                this.caricaDati();  
            }

            caricaMarche() {

               //console.log(this.props.marche);

                if (this.props.loadingMarche || this.props.marche.length  > 0 ){
                    return;
                }
              //  console.log('dovrei caricare le marche');   
                 this.props.onFetchMarche(this.props.token);
                 
            //     this.setState({loadingMarche: true});
            //     axios.get('/marche.json?auth=' + this.props.token)
            // .then(response => {
                               
            //     let marche = [];
            //    // console.log(response.data);
            //     for (let key in response.data){
            //         marche.push({
            //             ...response.data[key],
            //                 id: key
            //             });
            //         }
            //    this.setState({marcheLista: marche, loadingMarche: false});
            //   // console.log(this.state.marcheLista);
            // })  
            // .catch(error => {
            //     this.setState({loadingMarche: false});
            //     console.log(error);
            // });

        };

            
            
            handleChange = date => {
                const updatedVendita = {
                    ...this.state.vendita
                };
                updatedVendita['dataVendita']['value'] = date;
                this.setState({
                vendita: updatedVendita
                });
            };

            formVisibleHandler = (type) => { 
                const updatedFormVisible = {
                    ...this.state.formVisible
                };
                const updatedVendita = {
                    ...this.state.vendita
                }
                switch(type) {
                    case 'occhialeCompleto':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['montatura'] = true;
                        updatedFormVisible['lenti'] = true;
                        updatedVendita['tipoVendita']['value'] = 'occhialeCompleto';
                        updatedVendita['tipoMontatura']['value'] = 'vista';
                        updatedVendita['tipoMontatura']['validation']['required'] = true;
                        updatedVendita['tipoMontatura']['valid'] = true;
                        updatedVendita['marcaMontatura']['validation']['required'] = true;
                        updatedVendita['marcaMontatura']['valid'] = true;
                        updatedVendita['prezzoMontatura']['validation']['required'] = true;
                        updatedVendita['prezzoMontatura']['valid'] = true;
                        updatedVendita['tipoLenti']['validation']['required'] = true;
                        updatedVendita['tipoLenti']['valid'] = true;
                        updatedVendita['prezzoLenti']['validation']['required'] = true;
                        updatedVendita['prezzoLenti']['valid'] = true;

                        return this.setState({formVisible: updatedFormVisible, vendita: updatedVendita});
                    case 'occhialeSole':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['montatura'] = true;
                        updatedVendita['tipoVendita']['value'] = 'occhialeSole';
                        updatedVendita['tipoMontatura']['value'] = 'sole';
                        updatedVendita['tipoMontatura']['validation']['required'] = true;
                        updatedVendita['tipoMontatura']['valid'] = true;
                        updatedVendita['marcaMontatura']['validation']['required'] = true;
                        updatedVendita['marcaMontatura']['valid'] = true;
                        updatedVendita['prezzoMontatura']['validation']['required'] = true;
                        updatedVendita['prezzoMontatura']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'occhialeCompletoSole':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['montatura'] = true;
                        updatedFormVisible['lenti'] = true;
                        updatedVendita['tipoVendita']['value'] = 'occhialeCompletoSole';
                        updatedVendita['tipoMontatura']['value'] = 'sole';
                        updatedVendita['tipoMontatura']['validation']['required'] = true;
                        updatedVendita['tipoMontatura']['valid'] = true;
                        updatedVendita['marcaMontatura']['validation']['required'] = true;
                        updatedVendita['marcaMontatura']['valid'] = true;
                        updatedVendita['prezzoMontatura']['validation']['required'] = true;
                        updatedVendita['prezzoMontatura']['valid'] = true;
                        updatedVendita['tipoLenti']['validation']['required'] = true;
                        updatedVendita['tipoLenti']['valid'] = true;
                        updatedVendita['prezzoLenti']['validation']['required'] = true;
                        updatedVendita['prezzoLenti']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'montatura':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['montatura'] = true;
                        updatedVendita['tipoVendita']['value'] = 'montatura';
                        updatedVendita['tipoMontatura']['value'] = 'vista';
                        updatedVendita['tipoMontatura']['validation']['required'] = true;
                        updatedVendita['tipoMontatura']['valid'] = true;
                        updatedVendita['marcaMontatura']['validation']['required'] = true;
                        updatedVendita['marcaMontatura']['valid'] = true;
                        updatedVendita['prezzoMontatura']['validation']['required'] = true;
                        updatedVendita['prezzoMontatura']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'lenti':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['montatura'] = false;
                        updatedFormVisible['lenti'] = true;
                        updatedVendita['tipoVendita']['value'] = 'lenti';
                        updatedVendita['tipoLenti']['validation']['required'] = true;
                        updatedVendita['tipoLenti']['valid'] = true;
                        updatedVendita['prezzoLenti']['validation']['required'] = true;
                        updatedVendita['prezzoLenti']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'lac':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['lac'] = true;
                        updatedVendita['tipoVendita']['value'] = 'lac';
                        updatedVendita['tipoLac']['validation']['required'] = true;
                        updatedVendita['tipoLac']['valid'] = true;
                        updatedVendita['marcaLac']['validation']['required'] = true;
                        updatedVendita['marcaLac']['valid'] = true;
                        updatedVendita['prezzoLac']['validation']['required'] = true;
                        updatedVendita['prezzoLac']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'liquido':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['liquido'] = true;
                        updatedVendita['tipoVendita']['value'] = 'liquido';
                        updatedVendita['tipoLiquido']['validation']['required'] = true;
                        updatedVendita['tipoLiquido']['valid'] = true;
                        updatedVendita['prezzoLiquido']['validation']['required'] = true;
                        updatedVendita['prezzoLiquido']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: updatedVendita});
                    case 'altro':
                        updatedFormVisible['switchForm'] = false;
                        updatedFormVisible['altro'] = true;
                        updatedVendita['tipoVendita']['value'] = 'altro';
                        updatedVendita['altro']['validation']['required'] = true;
                        updatedVendita['altro']['valid'] = true;
                        updatedVendita['prezzoAltro']['validation']['required'] = true;
                        updatedVendita['prezzoAltro']['valid'] = true;
                        return this.setState({formVisible: updatedFormVisible, tipoVendita: 'altro'});
                    default: 
                        return this.setState({formVisible: updatedFormVisible});
                  }
            };

            cancellaHandler = () => {
                //this.setState(this.initialState);

                this.props.modalClosed();
            }

            checkValidity(value, rules) {
                let isValid = false;

                if (rules.required) {
                    isValid = value.trim() !== '';
                }

                
                if (!rules.required) {
                    isValid = true;
                }

                return isValid
            }

            inputChangeHandler = (event, id) => {
     //          console.log(event.target.value + ' elemento: ' + id);
                const updatedVendita = {
                    ...this.state.vendita
                };
                const updatedFormElement = {
                    ...updatedVendita[id]
                };
                
                updatedFormElement.value = (typeof event.target.type !== 'undefined' && event.target.type === 'checkbox') ? event.target.checked : event.target.value;
                
                updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation)
                updatedVendita[id] = updatedFormElement;
         //       console.log(updatedFormElement);

                this.setState({vendita: updatedVendita});
                
            }


            caricaDati = () => {
                if(this.state.loading){
                    return; //sacricamento in corso...non fare nulla
                }

                if(this.props.idVendita === this.state.currentIdVendita){
                    return; //vendita gia caricata
                }

                

               // console.log('NuovoIdVendita: ', this.props.idVendita, this.state.currentIdVendita);

                const iState = this.initialState;
                delete iState.marcheLista;
                
                this.setState({ ...iState,
                                loading: true });

                this.caricaMarche();  

            
                axios.get('/vendite/' +  this.props.idVendita + '.json?auth=' + this.props.token)
                    .then(response => {
                        
                      //  console.log(response);
                        let datiVendita = {
                            ...this.state.vendita
                        };
                        for (let formElementId in response.data){
                            response.data[formElementId] && (datiVendita[formElementId].value = response.data[formElementId]);
                           }
                       this.setState({vendita: datiVendita, loading: false, currentIdVendita: this.props.idVendita}, () => {
                           this.formVisibleHandler(this.state.vendita.tipoVendita.value)
                       });
                      //  console.log('Carica dati: ' + this.state.vendita.tipoVendita.value);
                        
                       
                    })  
                        .catch(error => {
                        this.setState({loading: false});
                        console.log(error);
                    });
                


            }

            aggiornaVenditaHandler = (event) => {
                
                    event.preventDefault();
                  // console.log(this.state.vendita);
                  this.setState({loading: true})
                  const vendita = {};
                  for (let formElementId in this.state.vendita){
                   vendita[formElementId] = this.state.vendita[formElementId].value;
                        // controllo la correttezza dei dati forniti nel form
                        if (!this.state.vendita[formElementId].valid){
                       //     console.log(formElementId, ' valore non corretto: ', this.state.vendita[formElementId].value, ' ma validido: ', this.state.vendita[formElementId].valid);
                            this.setState({formError: ' valore non corretto: ' + formElementId, loading: false})
                            return;
                            }
                  }

                  
            
                 
                  axios.patch('/vendite/' +  this.props.idVendita + '.json?auth=' + this.props.token , vendita)
                       .then(response => {
                           this.setState({loading: false});
                       })
                       .then(this.cancellaHandler)
                       .catch(error => {
                           this.setState({loading: false});
                       });
               }

               eliminaVenditaHandler = (event) => {
                
                event.preventDefault();
              // console.log(this.state.vendita);
              this.setState({loading: true})
                           
              axios.delete('/vendite/' +  this.props.idVendita + '.json?auth=' + this.props.token )
                   .then(response => {
                       this.setState({loading: false});
                   })
                   .then(this.cancellaHandler)
                   .catch(error => {
                       this.setState({loading: false});
                   });
           }
            



    render() {

        
        let switchForm = (
            <div className={classes.TipoVendita}>

                <div className={classes.azzurro} onClick={() => this.formVisibleHandler('vista')}>OCCHIALE COMPLETO</div>
                <div className={classes.acqua} onClick={() => this.formVisibleHandler('solo-lenti')}>LENTI</div>
                <div className={classes.rosso} onClick={() => this.formVisibleHandler('solo-montatura')} >MONTATURA</div>
                <div className={classes.violetto} onClick={() => this.formVisibleHandler('sole')} >SOLE</div>
                <div className={classes.purple} onClick={() => this.formVisibleHandler('sole-vista')}>SOLE/VISTA</div>
                <div className={classes.grigiochiaro} onClick={() => this.formVisibleHandler('lac')}>LAC</div>
                <div className={classes.verde} onClick={() => this.formVisibleHandler('liquido')}>LIQUIDO</div>
                <div className={classes.giallo} onClick={() => this.formVisibleHandler('altro')}>ALTRO</div>
              
                </div>
        );

      
        
      let montaturaForm = (
          <Aux>
            <p>MONTATURA</p>
            <FormGroup row>
                <Col >
                    
                    <InputGroup>
                    <InputGroupAddon addonType="prepend">
                    <InputGroupText>Marca montatura</InputGroupText>
                    </InputGroupAddon><Input 
                                        valid={this.state.vendita.marcaMontatura.valid} 
                                        invalid={!this.state.vendita.marcaMontatura.valid} 
                                        type="select" 
                                        name="marcaMontatura" 
                                        id="marcaMontatura"  
                                        value={this.state.vendita.marcaMontatura.value}
                                        onChange={(event) => this.inputChangeHandler(event, "marcaMontatura")}>
                                            <option value='' >Seleziona la marca...</option>
                                         {this.props.marche.filter(function(hero) { return hero.tipo === 'montatura' }) ? 
                                         this.props.marche.filter(function(hero) { return hero.tipo === 'montatura' })
                                         .sort((a, b) => (a.name > b.name) ? 1 : -1)
                                         .map( marca => (                                                        
                                                    <option value={marca.name} key={marca.id}  >{marca.name}</option>
                                                    ) 
                                            ) : null }


                                        </Input> 
                    </InputGroup>  
                    
                </Col>
                </FormGroup> 
                <FormGroup row>
                <Col >
                    <InputGroup>
                    <InputGroupAddon addonType="prepend">
                    <InputGroupText>Prezzo montatura</InputGroupText>
                    </InputGroupAddon>
                            <Input 
                            valid={this.state.vendita.prezzoMontatura.valid} 
                            invalid={!this.state.vendita.prezzoMontatura.valid} 
                            type="number" 
                            step="0.01"
                            name="prezzo" 
                            id="prezzoMontatura"  
                            placeholder="inserisci prezzo" 
                            value={this.state.vendita.prezzoMontatura.value}
                            onChange={(event) => this.inputChangeHandler(event, "prezzoMontatura")} />
                    <InputGroupAddon addonType="append">
                    <InputGroupText>€</InputGroupText>
                    </InputGroupAddon>
                    </InputGroup>
            </Col>
            </FormGroup>
            
            </Aux>
          );

          let lentiForm = (
              <Aux>
                  <p>LENTI</p>
              
            <div style={{textAlign: "left"}}>
      <FormGroup row>
            <Col >
            <Label for="exampleCheckbox">Tipo lenti</Label>
                <CustomInput type="radio" id="tipoLentiMonofocali" name="tipoLenti" label="Monofocali" value="monofocali" checked={this.state.vendita.tipoLenti.value === 'monofocali'} onChange={(event) => this.inputChangeHandler(event, "tipoLenti")}  />
                <CustomInput type="radio" id="tipoLentiMultifocali" name="tipoLenti" label="Multifocali (progressive)" value="multifocali" checked={this.state.vendita.tipoLenti.value === 'multifocali'} onChange={(event) => this.inputChangeHandler(event, "tipoLenti")} />
                <CustomInput type="radio" id="tipoLentiAltro" name="tipoLenti"  label="Altro" value="altro" checked={this.state.vendita.tipoLenti.value === 'altro'} onChange={(event) => this.inputChangeHandler(event, "tipoLenti")} />
            </ Col>
            <Col >
                    <Label for="exampleCheckbox">Extra</Label>
                    <div>
                    <CustomInput type="switch" id="colorate" label="colorate" checked={this.state.vendita.colorate.value} onChange={(event) => this.inputChangeHandler(event, "colorate")}/>
                    <CustomInput  type="switch" id="transition" label="transition"   checked={this.state.vendita.transition.value} onChange={(event) => this.inputChangeHandler(event, "transition")} />
                    </div>
            </ Col>
            </FormGroup>
            <FormGroup row>
            <Col >
                    <InputGroup>
                    <InputGroupAddon addonType="prepend">
                    <InputGroupText>Prezzo lenti</InputGroupText>
                    </InputGroupAddon>
                    <Input valid={this.state.vendita.prezzoLenti.valid} 
                    invalid={!this.state.vendita.prezzoLenti.valid} 
                    type="number" 
                    step="0.01"
                    name="prezzo" 
                    id="prezzoLenti"  
                    value={this.state.vendita.prezzoLenti.value}
                    placeholder="Prezzo lenti" 
                    onChange={(event) => this.inputChangeHandler(event, "prezzoLenti")} />
                    <InputGroupAddon addonType="append">
                    <InputGroupText>€</InputGroupText>
                    </InputGroupAddon>
                    </InputGroup>
            </Col>
      </FormGroup>
              </div>
              </Aux>
            );    
        
    let lacForm = (
                <Aux>
                    <p>LAC</p>
                
              <div style={{textAlign: "left"}}>
        <FormGroup row>
              <Col >
              <Label for="exampleCheckbox">Tipo lenti</Label>
                  <CustomInput type="radio" id="giornaliere" name="tipoLac" label="giornaliere" value="giornaliere"  checked={this.state.vendita.tipoLac.value === 'giornaliere'} onChange={(event) => this.inputChangeHandler(event, "tipoLac")}/>
                  <CustomInput type="radio" id="bisettimanali" name="tipoLac" label="bisettimanali" value="bisettimanali" checked={this.state.vendita.tipoLac.value === 'bisettimanali'} onChange={(event) => this.inputChangeHandler(event, "tipoLac")}/>
                  <CustomInput type="radio" id="mensili" name="tipoLac" label="mensili" value="mensili" checked={this.state.vendita.tipoLac.value === 'mensili'} onChange={(event) => this.inputChangeHandler(event, "tipoLac")}/>
                  <CustomInput type="radio" id="altro" name="tipoLac"  label="altro"  value="altro" checked={this.state.vendita.tipoLac.value === 'altro'} onChange={(event) => this.inputChangeHandler(event, "tipoLac")}/>
              </ Col>
              </FormGroup>
              <FormGroup row>
                <Col >
                    
                    <InputGroup>
                    <InputGroupAddon addonType="prepend">
                    <InputGroupText>Marca LAC</InputGroupText>
                    </InputGroupAddon><Input valid={this.state.vendita.marcaLac.valid} invalid={!this.state.vendita.marcaLac.valid} 
                            type="select" 
                            name="selectMarcaLac" 
                            id="marcaLac" 
                            value={this.state.vendita.marcaLac.value}
                            onChange={(event) => this.inputChangeHandler(event, "marcaLac")}>
                             <option value='' >Seleziona la marca...</option>
                                         {this.props.marche.filter(function(hero) { return hero.tipo === 'lac' }) ? 
                                         this.props.marche.filter(function(hero) { return hero.tipo === 'lac' })
                                         .sort((a, b) => (a.name > b.name) ? 1 : -1)
                                         .map( marca => (                                                        
                                                    <option value={marca.name} key={marca.id}  >{marca.name}</option>
                                                    ) 
                                            ) : null }
                        </Input> </InputGroup>  
                    
                </Col>
                </FormGroup>
              <FormGroup row>
              <Col >
                      <InputGroup>
                      <InputGroupAddon addonType="prepend">
                      <InputGroupText>Prezzo LAC</InputGroupText>
                      </InputGroupAddon>
                      <Input valid={this.state.vendita.prezzoLac.valid} 
                      invalid={!this.state.vendita.prezzoLac.valid}  
                      type="number" step="0.01"
                      name="prezzoLac" id="prezzoLac" 
                      placeholder="Prezzo LAC" 
                      value={this.state.vendita.prezzoLac.value}
                      onChange={(event) => this.inputChangeHandler(event, "prezzoLac")}/>
                      <InputGroupAddon addonType="append">
                      <InputGroupText>€</InputGroupText>
                      </InputGroupAddon>
                      </InputGroup>
              </Col>
        </FormGroup>
                </div>
                </Aux>
              );  


              let liquidoForm = (
                <Aux>
                    <p>LIQUIDO</p>
                
              <div style={{textAlign: "left"}}>
        <FormGroup row>
              <Col >
              <Label for="exampleCheckbox">Tipo lenti</Label>
                  <CustomInput type="radio" id="SoluzioneUnica" name="tipoLiquido" label="Soluzione unica" value="soluzione unica" checked={this.state.vendita.tipoLiquido.value === 'soluzione unica'} onChange={(event) => this.inputChangeHandler(event, "tipoLiquido")}/>
                  <CustomInput type="radio" id="Salina" name="tipoLiquido" label="Salina" value="salina"  checked={this.state.vendita.tipoLiquido.value === 'salina'} onChange={(event) => this.inputChangeHandler(event, "tipoLiquido")}/>
                  <CustomInput type="radio" id="Altro" name="tipoLiquido"  label="Altro" value="altro" checked={this.state.vendita.tipoLiquido.value === 'altro'} onChange={(event) => this.inputChangeHandler(event, "tipoLiquido")}/>
              </ Col>
              </FormGroup>
              <FormGroup row>
              <Col >
                      <InputGroup>
                      <InputGroupAddon addonType="prepend">
                      <InputGroupText>Prezzo Liquido</InputGroupText>
                      </InputGroupAddon>
                      <Input    valid={this.state.vendita.prezzoLiquido.valid} 
                                invalid={!this.state.vendita.prezzoLiquido.valid} 
                                type="number" 
                                step="0.01"
                                name="prezzoLiquido" 
                                id="prezzoLiquido" 
                                value={this.state.vendita.prezzoLiquido.value}
                                placeholder="Prezzo liquido" 
                                onChange={(event) => this.inputChangeHandler(event, "prezzoLiquido")} />
                      <InputGroupAddon addonType="append">
                      <InputGroupText>€</InputGroupText>
                      </InputGroupAddon>
                      </InputGroup>
              </Col>
        </FormGroup>
                </div>
                </Aux>
              );  

        let altroForm = (
                <Aux>
                    <p>Altro</p>
                
              <div style={{textAlign: "left"}}>
        <FormGroup row>
              <Col >
              <Label for="exampleCheckbox">Tipo altra vendita</Label>
                  <CustomInput type="radio" id="riparazione" name="altro" label="riparazione" value="riparazione" checked={this.state.vendita.altro.value === 'riparazione'} onChange={(event) => this.inputChangeHandler(event, "altro")}  />
                  <CustomInput type="radio" id="aste" name="altro" label="aste" value="aste" checked={this.state.vendita.altro.value === 'aste'}  onChange={(event) => this.inputChangeHandler(event, "altro")}/>
                  <CustomInput type="radio" id="accessori" name="altro"  label="accessori" checked={this.state.vendita.altro.value === 'accessori'}  value="accessori" onChange={(event) => this.inputChangeHandler(event, "altro")} />
                  <CustomInput type="radio" id="aggiuntivo" name="altro"  label="aggiuntivo" checked={this.state.vendita.altro.value === 'aggiuntivo'}  value="aggiuntivo" onChange={(event) => this.inputChangeHandler(event, "altro")}  />
              </ Col>
              </FormGroup>
              <FormGroup row>
              <Col >
                      <InputGroup>
                      <InputGroupAddon addonType="prepend">
                      <InputGroupText>Descrizione vendita</InputGroupText>
                      </InputGroupAddon>
                      <Input    valid={this.state.vendita.altro.valid} 
                                invalid={!this.state.vendita.altro.valid} 
                                type="text" name="altro" id="altro"  
                                placeholder="Scegli sopra o scrivi qui"
                                value = {this.state.vendita.altro.value}
                                onChange={(event) => this.inputChangeHandler(event, "altro")} />
                      <InputGroupAddon addonType="append">
                      <InputGroupText>€</InputGroupText>
                      </InputGroupAddon>
                      </InputGroup>
              </Col>
        </FormGroup>
              <FormGroup row>
              <Col >
                      <InputGroup>
                      <InputGroupAddon addonType="prepend">
                      <InputGroupText>Prezzo Altro</InputGroupText>
                      </InputGroupAddon>
                      <Input    valid={this.state.vendita.prezzoAltro.valid} 
                                invalid={!this.state.vendita.prezzoAltro.valid} 
                                type="number" step="0.01"
                                name="prezzoAltro" id="prezzoAltro"  
                                placeholder="Prezzo altro"
                                value={this.state.vendita.prezzoAltro.value}
                                onChange={(event) => this.inputChangeHandler(event, "prezzoAltro")} />
                      <InputGroupAddon addonType="append">
                      <InputGroupText>€</InputGroupText>
                      </InputGroupAddon>
                      </InputGroup>
              </Col>
        </FormGroup>
                </div>
                </Aux>
              );  

        return (
        
        <Aux>
            
            
                <Form className={classes.NuovaVenditaForm} onSubmit={this.aggiornaVenditaHandler}>
                <FormGroup row>
                    <Label  sm={5}>Data Vendita </Label>
                    <Col sm={4}>
                    <Calendario data={this.state.vendita.dataVendita.value} changed={(date) => this.handleChange(date)}  />
                    
                    </Col>      
                </FormGroup>
                
                
                
                { this.state.formVisible.switchForm && switchForm}
                { this.state.formVisible.montatura && montaturaForm}
                { this.state.formVisible.lenti && lentiForm}
                { this.state.formVisible.lac && lacForm}
                { this.state.formVisible.liquido && liquidoForm}
                { this.state.formVisible.altro && altroForm}
                
                { (this.state.loading || this.state.loadingMarche) && <Spinner color="primary" /> }<br />
                <p style={{color: "red"}}>{this.state.formError}</p>
               <Button color="primary" onClick={this.cancellaHandler} >Chiudi</Button>{' '}
               <Button color="danger" onClick={this.eliminaVenditaHandler}> Elimina vendita </Button> {' '}
               <Button type="submit" color="success" onClick={this.aggiornaVenditaHandler}> Salva </Button> 
               
            </Form>
            </Aux>
           
        )
           
        
    }
}
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        marche: state.marche.marche,
        loadingMarche: state.marche.loading,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchMarche: (token) => dispatch(actions.fetchMarche(token)),
        onAddMarca: (marcarData, token) => dispatch(actions.addMarca(marcarData, token)),
        onModificaMarca: (marcaData, token) => dispatch(actions.modificaMarca(marcaData, token)),
        onEliminaMarca: (marcaData, token) => dispatch(actions.eliminaMarca(marcaData, token))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ModificaVendita);
